import { IconTemplate } from '@components/Icon/IconTemplate';
import { rem } from 'polished';
import styled from 'styled-components';
import { breakpoints } from '../../styles/theme';

export const Transportation = styled.div`
    display: flex;
    flex-direction: column;
    margin: ${rem(45)} 0;
    padding: ${rem(10)};

    @media (min-width: ${breakpoints.md}px) {
        flex-direction: row;
        justify-content: space-between;
    }

    @media (min-width: ${breakpoints.lg}px) {
        padding: ${rem(10)} 0;
    }
`;

export const TransportationOptions = styled.div`
    width: 100%;
    padding: ${rem(10)} 0;

    @media (min-width: ${breakpoints.md}px) {
        width: 65%;
    }
`;

export const TransportationOption = styled.div``;

export const TransportationHeader = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding: ${rem(20)} 0;
    border-bottom: 1px solid ${({ theme }) => theme.colors.border};
    cursor: pointer;
`;

export const TransportationHeaderTitle = styled.span`
    font-size: ${rem(18)};
`;

export const TransportationHeaderIcon = styled(IconTemplate)`
    svg {
        width: ${rem(20)};
        height: ${rem(20)};
    }

    &.isOpen {
        svg {
            transform: rotate(180deg);
        }
    }
`;

export const TransportationDescription = styled.div`
    padding: ${rem(10)} 0;

    .withBorder {
        text-decoration: underline;
        display: block;
        padding: ${rem(20)} 0;
    }

    li {
        margin: ${rem(5)} 0;
    }
`;
